/*
 * @Date: 2020-08-20 11:13:13
 * @Author: MX
 * @LastEditTime: 2020-10-30 10:00:39
 * @Description: 
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/style/index.scss'
import ElementUI from 'element-ui';
import '@/assets/style/element-variables.scss'
// import 'element-ui/lib/theme-chalk/index.css';
import * as Api from '@/api'
import  '@/assets/js/agent.vue.min.js'
import './utils/directive.js'
Vue.use(ElementUI);

Vue.config.productionTip = false
Vue.prototype.$API = Api

router.beforeEach((to, from, next) => {
	if(to.path === '/login' && from.path !== '/register') {
		sessionStorage.setItem('lastRouter', from.path)
	}
  next()
})
new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
